var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596266",
    d: "M4.16469553,12.6143563 C5.20455063,13.4796017 6.54150254,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,6.54150254 13.4796017,5.20455063 12.6143563,4.16469553 L4.16469553,12.6143563 Z M13.3240166,3.45503523 C14.3690045,4.67797776 15,6.26530043 15,8 C15,11.8659932 11.8659932,15 8,15 C6.26530043,15 4.67797776,14.3690045 3.45503523,13.3240166 L1.77905184,15 L1,14.2209482 L14.2209482,1 L15,1.77905184 L13.3240166,3.45503523 Z M2.0268035,11.6517007 C1.37547017,10.5885676 1,9.33813167 1,8 C1,4.13400675 4.13400675,1 8,1 C9.33813167,1 10.5885676,1.37547017 11.6517007,2.0268035 L10.9208165,2.75768766 C10.0564215,2.27504742 9.06033115,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,9.06033115 2.27504742,10.0564215 2.75768766,10.9208165 L2.0268035,11.6517007 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.a3c84511.svg";
export { ForwardRef as ReactComponent };